module.exports = __webpack_public_path__ + "img/2025-10-15d_3.93c01f23.jpg";